import {
  Dispatch,
  useCallback,
  useState,
  SetStateAction,
  FocusEvent,
  DOMAttributes,
} from 'react';

export interface SharedFocusedProps
  extends Pick<DOMAttributes<HTMLElement>, 'onFocus' | 'onBlur'> {
  focused?: boolean;
}

export type ReturnedFocusedProps = SharedFocusedProps &
  Required<Pick<SharedFocusedProps, 'focused'>>;

export function useFocused({
  focused,
  onFocus,
  onBlur,
}: SharedFocusedProps): ReturnedFocusedProps {
  const [focusedState, setFocusedState]: [
    boolean,
    Dispatch<SetStateAction<boolean>>,
  ] = useState<boolean>(false);

  const handleFocus = useCallback(
    (evt: FocusEvent<HTMLElement>): void => {
      if (onFocus) onFocus(evt);
      setFocusedState(true);
    },
    [onFocus]
  );

  const handleBlur = useCallback(
    (evt: FocusEvent<HTMLElement>): void => {
      if (onBlur) onBlur(evt);
      setFocusedState(false);
    },
    [onBlur]
  );

  return {
    focused: focused != null ? focused : focusedState,
    onFocus: focusedState ? onFocus : handleFocus,
    onBlur: focusedState ? handleBlur : onBlur,
  };
}
